const API = {
  TOKEN: {
    ACCESS: `api/token/`,
    REFRESH: `api/token/refresh/`
  },
  ROLES: {
    INDEX: `roles/`
  },
  SPECKLE: {
    BASE: `speckle`,
    SEND: `speckle/send/`
  },
  CORE: {
    PROJECTS: {
      INDEX: `projects/`
    },
    PROJECT_USERS: {
      INDEX: `project_users/`
    },
    USERS: {
      INDEX: `users/`,
      CURRENT_USER: `users/current_user/`
    },
    CALCULATIONS: {
      INDEX: `calculations/`,
      CHECK_PROJECT_PARAMS: (id: number) => `calculations/${id}/check_project_params/`,
      UPDATE_PROJECT_PARAMS: (id: number) => `calculations/${id}/update_project_params/`,
      DUPLICATE: (id: number) => `calculations/${id}/duplicate/`,
      BULK_DUPLICATE: `calculations/bulk_duplicate/`,
      EXPORT_EXCEL: (id: number) => `calculations/${id}/export_excel/`,
      CELERY_CALCULATE: (id: number) => `calculations/${id}/celery_calculate/`,
      EXPORT_ERROR: (id: number) => `calculations/${id}/get_error_file/`,
      GET_CALCULATION_PROGRESS_STEPS: (id: number) =>
        `calculations/${id}/get_calculation_progress_steps/`,
      GET_CALCULATION_PROGRESS: (id: number) => `calculations/${id}/get_calculation_progress/`
    },
    MATERIALS: {
      INDEX: `materials/`
    },
    CUSTOM_ROCK_GRADINGS: {
      INDEX: `custom_rock_gradings/`
    },
    COST: {
      INDEX: `cost/`
    },
    CROSS_SECTION: {
      INDEX: `cross_sections/`,
      EXPORT_EXCEL: (id: number) => `cross_sections/${id}/export_excel/`,
      EXPORT_MATHCAD: (id: number) => `cross_sections/${id}/export_mathcad/`
    }
  },
  SHIP: {
    SHIP: {
      INDEX: `ships/`,
      IMPORT_SHIPS: 'ships/import_ship/'
    },
    SHIP_API: {
      AUTH: 'ships/ship_api_authorization/'
    }
  }
}

export default API
